import { FlightChangeCase, FlightChangeCaseRawResponse } from '../types';
import { caseStatusMapper, notificationStatusMapper } from './statusMapper';

export class FlightChangeCaseMapper {
    mapSingle(raw: FlightChangeCaseRawResponse): FlightChangeCase {
        return {
            ...raw,
            status: caseStatusMapper.map(raw.status),
            notificationStatus: raw.notificationStatus 
                ? notificationStatusMapper.map(raw.notificationStatus) 
                : undefined
        };
    }

    mapArray(rawArray: FlightChangeCaseRawResponse[]): FlightChangeCase[] {
        return rawArray.map(raw => this.mapSingle(raw));
    }
}

export const flightChangeCaseMapper = new FlightChangeCaseMapper();

